export default __webpack_public_path__ + "media/images/logos/cisrs-logo-656fa07b45fdfd978dfc2dfacaa8a4c0.png";